import type { LoadState } from './workflowShared';

interface OptionsStatusProps {
  loadState: LoadState;
  loadError: string;
  onRetry: () => void;
}

function OptionsStatus({ loadState, loadError, onRetry }: OptionsStatusProps) {
  if (loadState === 'loading' || loadState === 'idle') {
    return (
      <div className="status-box muted">
        Loading backend skills and AI agents...
      </div>
    );
  }

  if (loadState === 'error') {
    return (
      <div className="status-box error" role="alert">
        <span>Could not load backend options.</span>
        <span>{loadError}</span>
        <button className="inline-action" type="button" onClick={onRetry}>
          Retry
        </button>
      </div>
    );
  }

  return null;
}

export default OptionsStatus;
